export default __webpack_public_path__ + "static/seller-background-1094915278b480ff200b8a448ac8765f.jpg";